<script>
import RosterCreate from "./RosterCreate.vue";

export default {
  name: "RosterActualView",
  extends: RosterCreate,
};
</script>
